import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Card,
  CardHeader,
  CardContent,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Chip,
  Typography,
  Box,
  IconButton,
  Tooltip,
} from '@mui/material';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import { 
  Edit as EditIcon, 
  Visibility as VisibilityIcon,
  WhatsApp as WhatsAppIcon
} from '@mui/icons-material';

const getEstadoColor = (estado) => {
  switch (estado) {
    case 'Programada':
      return 'primary';
    case 'Confirmada':
      return 'success';
    case 'Cancelada':
      return 'error';
    case 'Realizada':
      return 'default';
    case 'No asistió':
      return 'warning';
    default:
      return 'default';
  }
};

const getEstadoDisplay = (estado) => {
  switch (estado) {
    case 'Programada':
      return 'Confirmada';
    case 'Cancelada':
      return 'Justificada';
    default:
      return estado;
  }
};

const RecentAppointments = ({ citas = [] }) => {
 
  

  // Usar citas proporcionadas o las de ejemplo si no hay citas
const citasMostrar = citas;

  // Formatear hora a formato 12 horas (AM/PM)
  const formatTime = (time) => {
    if (!time) return '';
    try {
      return format(new Date(`2000-01-01T${time}`), 'h:mm a', { locale: es });
    } catch (error) {
      return time;
    }
  };

   

  // Formatear fecha
  const formatDate = (date) => {
    if (!date) return '';
    try {
      return format(new Date(date), 'dd/MM/yyyy', { locale: es });
    } catch (error) {
      return date;
    }
  };

  return (
    <Card>
      <CardHeader
        title="Próximas Citas"
        action={
          <Button
            component={RouterLink}
            to="/citas"
            color="primary"
            size="small"
          >
            Ver todas
          </Button>
        }
      />
      <Divider />
      <CardContent sx={{ p: 0 }}>
        {citasMostrar.length === 0 ? (
          <Box sx={{ p: 3, textAlign: 'center' }}>
            <Typography variant="body2" color="textSecondary">
              No hay citas programadas próximamente
            </Typography>
          </Box>
        ) : (
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Paciente</TableCell>
                  <TableCell>Especialista</TableCell>
                  <TableCell>Especialidad</TableCell>
                  <TableCell>Fecha</TableCell>
                  <TableCell>Hora</TableCell>
                  <TableCell>Estado</TableCell>
                  <TableCell align="right">Acciones</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {citasMostrar.map((cita) => (
                  <TableRow key={cita.id}>
                    <TableCell>
                      {cita.paciente
                        ? `${cita.paciente.nombres} ${cita.paciente.apellidos}`
                        : 'Sin paciente'}
                    </TableCell>
                    <TableCell>
                      {cita.especialista && cita.especialista.usuario
                        ? `${cita.especialista.usuario.nombre} ${cita.especialista.usuario.apellidos}`
                        : 'Sin especialista'}
                    </TableCell>
                    <TableCell>
                      {cita.especialidad ? cita.especialidad.nombre : ''}
                    </TableCell>
                    <TableCell>{formatDate(cita.fecha)}</TableCell>
                    <TableCell>{formatTime(cita.hora_inicio)}</TableCell>
                    <TableCell>
                      <Chip
                        label={getEstadoDisplay(cita.estado)}
                        color={getEstadoColor(cita.estado)}
                        size="small"
                      />
                    </TableCell>
                    <TableCell align="right">
                      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Tooltip title="Enviar recordatorio">
                          <IconButton
                            size="small"
                            color="primary"
                            sx={{ mr: 1 }}
                          >
                            <WhatsAppIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Ver detalles">
                          <IconButton
                            component={RouterLink}
                            to={`/citas/${cita.id}`}
                            size="small"
                            color="info"
                            sx={{ mr: 1 }}
                          >
                            <VisibilityIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Editar cita">
                          <IconButton
                            component={RouterLink}
                            to={`/citas/editar/${cita.id}`}
                            size="small"
                            color="warning"
                          >
                            <EditIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </CardContent>
    </Card>
  );
};

export default RecentAppointments;